// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__X2Ec6","type":"styles_type__1-Dbh","choices":"styles_choices__2Ky2y"};